import React, {useEffect, useState} from 'react';
import {withStyles} from "@material-ui/core/styles";

const styles = {
  truncText: {
    flex: 1,
    marginLeft: '0.5rem',
    overflow: 'hidden',
    fontSize:'0.85rem',
    fontWeight:'300',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
  },
  showText: {
    flex: 1,
    marginLeft: '0.5rem',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
  },
}

function TruncatedDisplay(props) {
  const {children, className, classes, rows, style, open, ...divProps} = props;

  const [showText, setShowText] = useState(!!open);
  const elStyle = !rows ? style : {WebkitLineClamp: rows, ...style};

  useEffect(() => {
    setShowText(!!open)
  }, [open]);
  return (
    <div
      title={!showText ? children.toString() : null}
      className={`${showText ? classes.showText : classes.truncText} ${className}`}
      onClick={e => {
        setShowText(!showText);
      }}
      {...divProps}
      style={elStyle}
    >
      {children}
    </div>
  )
}

export default withStyles(styles)(TruncatedDisplay);